export const CONTRACT_TABS = [
  { id: "maintenance", contractType: 1, labelKey: "fleetMaintenance" },
  { id: "leasing", contractType: 2, labelKey: "leasing" },
  { id: "cashCustomer", contractType: 3, labelKey: "cashCustomer" },
];

export const contractTypeFromTab = (tab) =>
  CONTRACT_TABS.find((item) => item.id === tab)?.contractType || 1;

export const tabFromContractType = (value) =>
  CONTRACT_TABS.find((item) => item.contractType === Number(value))?.id ||
  "maintenance";

export const USER_TYPE = {
  OWNER: -1,
  USER: 1,
  ADMIN: 2,
  ACCOUNT_ADMIN: 3,
  SERVICE_PROVIDER: 4,
  RESELLER: 5,
  DISTRIBUTOR: 6,
};

export const attributesDefaultValue = {
  distanceUnit: "km",
  speedUnit: "kmh",
  volumeUnit: "ltr",
  measurementStandard: "metric",
  currencies: "SAR",
  isDriverActive: true,
};

export const accountsFormDefaults = {
  c_taxNumber: "",
  c_idIssuer: "MC",
  c_productType: "IMV",
  c_productStatus: "A",
  c_defaultStatus: "",
  c_goodsServices: "ALOTH",
  c_schemeId: "CRN",
  c_country: "United Arab Emirates",
  c_countryArabic: "الإمارات العربية المتحدة",
};

export const emptyIdentityForm = () => ({
  name: "",
  accountName: "",
  nameArabic: "",
  email: "",
  accountEmail: "",
  password: "",
  confirmPassword: "",
  attributes: { ...attributesDefaultValue },
  phone: "971",
  map: "",
  latitude: "",
  longitude: "",
  zoom: "",
  twelveHourFormat: "",
  coordinateFormat: "",
  poiLayer: "",
  disabled: "",
  admin: "",
  readonly: "",
  deviceReadonly: "",
  limitCommands: "",
  deviceLimit: 0,
  userLimit: 0,
  vehicleLimit: 0,
  creditPeriod: "0",
  token: "",
  expirationTime: null,
  roleId: "",
  userType: "",
  amUserId: null,
  administrator: false,
  accountId: 0,
  parentId: 0,
  monthlyRevenueTarget: "",
  yearlyRevenueTarget: "",
  status: "",
  vatPercentage: 5,
  markup: 5,
  pacContractId: "",
  contractType: "",
  contractName: "",
  contractNumber: "",
  accountDescription: "",
  accountContact: "",
  customerNumber: "",
  creditLimit: "",
  contractStartDate: new Date().toISOString(),
  contractEndDate: "",
  settleDate: "",
  defaultSatisfactionDate: "",
  customerType: "",
  garage: "",
  companyId: "",
  city: "",
});

export const copyLoginUserDefaults = (logInUser) => ({
  coordinateFormat: logInUser?.coordinateFormat,
  poiLayer: logInUser?.poiLayer,
  latitude: logInUser?.latitude || 25.2048,
  longitude: logInUser?.longitude || 55.2708,
  zoom: logInUser?.zoom || 3,
  map: logInUser?.map,
  attributes: {
    "web.liveRouteLength": logInUser?.attributes?.["web.liveRouteLength"],
    "web.maxZoom": logInUser?.attributes?.["web.maxZoom"],
    "web.selectZoom": logInUser?.attributes?.["web.selectZoom"],
    timezone: logInUser?.attributes?.timezone,
    distanceUnit: logInUser?.attributes?.distanceUnit,
    speedUnit: logInUser?.attributes?.speedUnit,
    volumeUnit: logInUser?.attributes?.volumeUnit,
    measurementStandard: logInUser?.attributes?.measurementStandard,
    currencyLabel: logInUser?.attributes?.currencyLabel || "AED",
    isDriverActive: true,
  },
});

export const SCHEME_ID_LIST = [
  { key: 1, name: "TIN" },
  { key: 2, name: "CRN" },
  { key: 3, name: "MOM" },
  { key: 4, name: "MLS" },
  { key: 5, name: "700" },
  { key: 6, name: "SAG" },
  { key: 7, name: "NAT" },
  { key: 8, name: "GCC" },
  { key: 9, name: "IQA" },
  { key: 10, name: "OTH" },
];
